import api from '@/services/api'

const state = {
  states: [],
  towns: [],
  months: ['Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno',
           'Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre'],
  monthsShort: 'Gen_Feb_Mar_Apr_Mag_Giu_Lug_Ago_Set_Ott_Nov_Dic'.split('_'),
  days: ['Lunedì', 'Martedì', 'Mercoledì', 'Giovedì', 'Venerdì', 'Sabato', 'Domenica'],
  daysShort: ['Lu', 'Ma', 'Me', 'Gi', 'Ve', 'Sa', 'Do'],
}

// getters
const getters = {}

// actions
const actions = {
  states({ commit }) {
    return new Promise( (resolve) => {
      api().post('/city/states').then( (response) => {
        commit('states', response.data.data)
        resolve()
      })
    })
  },
  towns({ commit }, selected_state) {
    return new Promise( (resolve) => {
      api().post('/city/' + selected_state + '/towns').then( (response) => {
        commit('towns', response.data.data)
        resolve()
      })
    })
  }
}

// mutations
const mutations = {
  states(state, states) {
    state.states = states
  },
  towns(state, towns) {
    state.towns = towns
  },
  resetTowns(state) {
    state.towns = []
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/utils.js